module.exports = __webpack_public_path__ + "static/media/33_tn.ff93b144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/33_tn.jpg
// module id = 669
// module chunks = 0